import { z } from 'zod';
import { uuid } from './fields';

/**
 * Trip Item Labels — flat label keywords applied to trip items (data-model.md
 * §11, PRD §9), the main organizing primitive. Built-ins like `to buy` are just
 * reserved label strings (see `BUILTIN_LABELS` in enums.ts), not a separate
 * type. Rows are immutable (relabel = delete + insert), hence no `updatedAt`.
 * REST endpoints land in T19; DTO shapes pinned now.
 */

/** Full label resource (response shape). */
export const TripItemLabel = z.object({
  id: uuid(),
  tripItemId: uuid(),
  label: z.string(),
  createdAt: z.string().datetime(),
});
export type TripItemLabel = z.infer<typeof TripItemLabel>;

/**
 * Add-label body (T19). Normalized/trimmed in the app layer; stored verbatim.
 * Non-empty after trim; deduped per item via the unique(trip_item_id, label).
 */
export const CreateTripItemLabelInput = z.object({
  label: z.string().trim().min(1).max(200),
});
export type CreateTripItemLabelInput = z.infer<typeof CreateTripItemLabelInput>;

/** Remove-label body (T19). */
export const DeleteTripItemLabelInput = CreateTripItemLabelInput;
export type DeleteTripItemLabelInput = z.infer<typeof DeleteTripItemLabelInput>;
